import * as React from 'react';
import {Badge, Card, OverlayTrigger, Tooltip} from 'react-bootstrap';
import { useState } from 'react';
import { useHistory } from 'react-router';
import {useSelector} from "react-redux";

const AnnouncementCard = ({ media, language, t }) => {
    const [open, setOpen] = useState(false);
    const [hovered, setHovered] = useState(false);
    const history = useHistory();
    const userLogin = useSelector((state) => state.userLogin);
    const { userInfo } = userLogin;

    return (
        <>
            <Card
                key={media._id}
                bg='light'
                text='dark'
                className='mb-sm-4 position-relative'
            >
                <div
                    style={{
                        position: 'absolute',
                        top: '-5px',
                        right: '-7px',
                        transform: `${
                            hovered ? 'scale(1.5,1.5)' : 'scale(1,1)'
                        }`,
                    }}
                >
                    <OverlayTrigger
                        placement='right'
                        overlay={
                            <Tooltip key='right' id={`tooltip-right`}>
                                {t('card_edit')}
                            </Tooltip>
                        }
                    >
                        <i
                            className='fas fa-edit fa-lg'
                            onMouseEnter={() => setHovered(true)}
                            onMouseLeave={() => setHovered(false)}
                            onClick={(e) => {
                                e.preventDefault();
                                history.push(`/announcements/${media._id}`);
                            }}
                        />
                    </OverlayTrigger>
                </div>

                <Card.Header onClick={() => setOpen(!open)}>
                    <Card.Title className='text-center'>
                        {media.name}
                    </Card.Title>
                    {/*<Card.Subtitle className='text-center text-muted'>
                        <div>Fájl: {media.fileName}</div>
                    </Card.Subtitle>*/}
                </Card.Header>

                <Card.Body>
                    <span style={{ fontWeight: 'bold' }}>{t('card_description')}: </span>
                    {media.description}
                    <br/>
                    <span style={{ fontWeight: 'bold' }}>{t('card_media_duration')}: </span>
                    {media.duration.toFixed(2)} {t('media_duration_unit')}
                    <div className={'text-center pt-3'}>
                        <audio style={{width: 100 + '%'}} className={''} key = {media.name}  controls
                               src={`https://smadify.api.bravo-gw.sigmanet.cloud/api/stream/${media.user}/announcement/${media.fileName}`} type={media.fileName.toLowerCase().endsWith('.mp3') ? `audio/mpeg`: "audio/wav"}/>
                    </div>

                </Card.Body>

                <Card.Footer className='pl-2 pr-2 pt-3'>
                    {media.tags.map((tag) => (
                        <Badge
                            key={tag._id}
                            pill
                            variant='dark'
                            className='p-2 mb-1 mr-1'
                        >
                            {tag.name}
                        </Badge>
                    ))}
                </Card.Footer>
            </Card>
        </>
    );
};

export default AnnouncementCard;
